import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react'

interface EhrLaunchErrorPageProps {
  title?: string
}

export const EhrLaunchErrorPage = ({
  title = 'Launch could not be started',
}: EhrLaunchErrorPageProps) => (
  <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" p={6}>
    <VStack spacing={4} maxW="520px" textAlign="center">
      <Heading size="md">{title}</Heading>
      <Text>Please return to the EHR and launch RxPad again.</Text>
      <Button onClick={() => (window.location.href = '/')}>Back to RxPad</Button>
    </VStack>
  </Box>
)
